module.exports = __webpack_public_path__ + "img/SketchPng45402e502be3756b3ec36ec85364510fdf9d87e2b1d0ef1122bc243475b21f38.5b22db02.png";